import React from 'react';

import { Modal, Form, Input, Checkbox, Button, Space, InputNumber, Select, Divider } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}


const { Option } = Select;


class MemberConfigEdit extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Form.Item
                            label="会员等级"
                            name="level"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="等级名称"
                            name="name"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="猫粮抵扣上限"
                            name="limitOfDeduction"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <InputNumber />
                        </Form.Item>

                        <Form.Item
                            label="购买上限"
                            name="limitOfBuy"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <InputNumber />
                        </Form.Item>

                        <Form.Item
                            label="会员福利"
                            name="benefits"
                        >
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                            >
                                <Option value="1">签到领猫粮</Option>
                                <Option value="2">猫粮抵扣</Option>
                            </Select>
                        </Form.Item>

                        <Divider />

                        <Form.Item {...tailLayout}>
                            <Space size="large">
                                <Button onClick={this.cancelModal}>取消</Button>
                                <Button type="primary" htmlType="submit">确认提交</Button>
                            </Space>

                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default MemberConfigEdit;